import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {createHistory} from 'history';
import {useRouterHistory} from 'react-router';
import Root from './Router';
import {syncHistoryWithStore} from 'react-router-redux';
import createStore from './Redux';

import applyAbTesting from "./abtest";
import I18N from '../data/i18n';
import "./scss/main.scss";

// require("./utility/wonderpush");

applyAbTesting();

const browserHistory = useRouterHistory(createHistory)({
    basename: '',
});

const store = createStore();
const history = syncHistoryWithStore(browserHistory, store);

const render = (Component) => {
    return ReactDOM.render(
        <Provider store={store} history={history}>
            <div>
                <Component history={history}/>
            </div>
        </Provider>,
        document.getElementById('root'),
    );
};

window["I18N"] = I18N;

window["App"] = render(Root);

if (module.hot) {
    module.hot.accept('./Router', () => {
        const newApp = require('./Router').default;
        render(newApp);
    });
}